import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import BaseComp from 'wix-style-react/dist/src/Popover';
import { classes, st } from './Popover.st.css';

var Popover = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Popover, _React$PureComponent);

  var _super = _createSuper(Popover);

  function Popover() {
    _classCallCheck(this, Popover);

    return _super.apply(this, arguments);
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(BaseComp, _extends({
        className: st(classes.root, className)
      }, rest));
    }
  }]);

  return Popover;
}(React.PureComponent);

Popover.displayName = 'Popover';
Popover.Content = BaseComp.Content;
Popover.Element = BaseComp.Element;
Popover.propTypes = {
  /**Adds enter and exit animation */
  animate: PropTypes.bool,

  /** Enables calculations in relation to a dom element */
  appendTo: PropTypes.oneOf(['window', 'scrollParent', 'parent', 'viewport']),

  /** children to render that will be the target of the popover */
  children: BaseComp.propTypes.children,

  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,

  /** The classname to be passed to the popover's content container */
  contentClassName: PropTypes.string,

  /** Custom arrow element */
  customArrow: PropTypes.func,

  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Breaking change: When true - onClickOutside will be called only when popover content is shown */
  disableClickOutsideWhenClosed: PropTypes.bool,

  /** popovers content is set to minimum width of trigger element, but it can expand up to the value of maxWidth. */
  dynamicWidth: PropTypes.bool,

  /** Clicking on elements with this excluded class will will not trigger onClickOutside callback */
  excludeClass: PropTypes.string,

  /**
   * Whether to enable the fixed behaviour. This behaviour is used to keep the `<Popover/>` at it's
   * original placement even when it's being positioned outside the boundary.
   */
  fixed: PropTypes.bool,

  /**
   * Whether to enable the flip behaviour. This behaviour is used to flip the `<Popover/>`'s placement
   * when it starts to overlap the target element (`<Popover.Element/>`).
   */
  flip: PropTypes.bool,

  /* stretch trigger element to the width of its container. */
  fluid: PropTypes.bool,

  /** Hide Delay in ms */
  hideDelay: PropTypes.number,

  /** Id */
  id: PropTypes.string,

  /**
   * popover content maxWidth value
   * - `number` value which converts to css with `px`
   * - `string` value that contains `px`
   */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
        * popover content minWidth value
        * - `number` value which converts to css with `px`
        * - `string` value that contains `px`
        */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Moves arrow by amount */
  moveArrowTo: PropTypes.number,

  /** Moves popover relative to the parent */
  moveBy: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),

  /** onClick on the component */
  onClick: PropTypes.func,

  /** Provides callback to invoke when clicked outside of the popover */
  onClickOutside: PropTypes.func,

  /** onKeyDown on the target component */
  onKeyDown: PropTypes.func,

  /** onMouseEnter on the component */
  onMouseEnter: PropTypes.func,

  /** onMouseLeave on the component */
  onMouseLeave: PropTypes.func,

  /** The location to display the content */
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']).isRequired,

  /** target element role value */
  role: PropTypes.string,

  /** Show show arrow from the content */
  showArrow: PropTypes.bool,

  /** Show Delay in ms */
  showDelay: PropTypes.number,

  /** The location to display the content */
  shown: PropTypes.bool.isRequired,

  /** Inline style */
  style: PropTypes.object,

  /** Animation duration, time in ms, default is 0 */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * popover content width value
   * - `number` value which converts to css with `px`
   * - `string` value that contains `px`
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** popover z-index */
  zIndex: PropTypes.number
};
Popover.defaultProps = {
  timeout: 0,
  appendTo: 'window',
  animate: false
};
export default Popover;